import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import HotSpot from './HotSpotBtn';
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {SCREEN_CONFIG} from '../../../models/dialogModels';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';

class HotspotScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.screen),
            status: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status,// objectConstants.STATUS_IN_PROGRESS,
            callbacks: {},
            assets: {
                background: {
                    src: "",
                },
                hotspotBackground: {
                    src: "",
                }
            },
            activeScreen: {},
            viewedScreens: [],
            hotspotScreens: [],
            introductionScreen: {},
            conclusionScreen: {},
            enabledScreens: [],
            completeScreens: [],
            checkNextSlideBtnState: false,
            hasIntroduction: this.props.hasIntroduction,
            introductionStatus: objectConstants.STATUS_NOT_STARTED,
            launchIntroduction: false,
            hasConclusion: this.props.hasConclusion,
            conclusionStatus: objectConstants.STATUS_NOT_STARTED,
            launchConclusion: false,
            scrollState: "",
            checkScrollPos: false,
            producerNotes: appHelper.getScreenNotes(undefined, this.props.screen),
            screenIsReady: this.props.screen.sub_screens.length > 0 && appHelper.canSeeContent(this.props.screen),
            doSetRenderedScreens: false,
            setEnabledHotSpots: false,
            isOpenNavigation: appHelper.getBiteById(this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
            introduction_label: appHelper.getLocaleString("introduction_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            conclusion_label: appHelper.getLocaleString("conclusion_label"),
            scroll_label: appHelper.getLocaleString("scroll_label"),

        };

        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.readySetRenderedScreens = this.readySetRenderedScreens.bind(this);
        this.setEnabledHotSpots = this.setEnabledHotSpots.bind(this);
        this.setActiveHotspot = this.setActiveHotspot.bind(this);
        this.onSubScreenComplete = this.onSubScreenComplete.bind(this);
        this.goToNextSubScreen = this.goToNextSubScreen.bind(this);
        this.hasNextSubScreen = this.hasNextSubScreen.bind(this);
        this.checkScreenComplete = this.checkScreenComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setRenderedScreens = this.setRenderedScreens.bind(this);
        this.setScreenHasBeenViewed = this.setScreenHasBeenViewed.bind(this);
        this.checkScreenIsEnabled = this.checkScreenIsEnabled.bind(this);
        this.completeScreen = this.completeScreen.bind(this);
        this.launchScreen = this.launchScreen.bind(this);
        this.checkHotSpotsAreComplete = this.checkHotSpotsAreComplete.bind(this);
        this.onCloseScreen = this.onCloseScreen.bind(this);
        this.showFooter = this.showFooter.bind(this);
        this.hasFooterClass = this.hasFooterClass.bind(this);
        this.showIntroduction = this.showIntroduction.bind(this);
        this.showConclusion = this.showConclusion.bind(this);
        this.checkScrolling = this.checkScrolling.bind(this);
        this.setScreenTitle = this.setScreenTitle.bind(this);
        this.readyIntroduction = this.readyIntroduction.bind(this);
        this.readyConclusion = this.readyConclusion.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.getCompletedSubScreens = this.getCompletedSubScreens.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.allowScroll = this.allowScroll.bind(this);
        this.setButtonColour = this.setButtonColour.bind(this);
    }


    componentDidMount() {
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.getAssets();
        this.setCallbacks();
        if (this.state.screenIsReady) {
            //this.setEnabledHotSpots();
            let readySetRenderedScreens = this.readySetRenderedScreens;
            setTimeout(function(){
                readySetRenderedScreens();
            },1000);
            //this.readySetRenderedScreens();
            //this.setRenderedScreens();
        } else {
            this.setScreenNotReadyYet();
        }

        this.setScreenTitle();
        let feed = this.refs[`${this.state.screen.screen_id}_feed`];
        feed.addEventListener("scroll", this.checkScrolling);

        //this.setActiveHotspot(this.state.screen.sub_screens[0]);

    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        let introductionStatus = this.state.introductionStatus;
        let conclusionStatus = this.state.conclusionStatus;

        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({},nextProps.userData),
                //introductionStatus: introductionStatus,
                setEnabledHotSpots: true
            });
        }

        if (this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE && appHelper.isDefined(this.state.introductionScreen.data)) {
            introductionStatus = userDataHelper.getSubScreenUserData(nextProps.userData, this.state.screen.screen_id, this.state.introductionScreen.data.screen_id).status;
            this.setState({
                introductionStatus: introductionStatus,
                //setEnabledHotSpots: true
            });
        }

        if (this.state.hasConclusion && conclusionStatus !== objectConstants.STATUS_COMPLETE && appHelper.isDefined(this.state.conclusionScreen.data)) {
            conclusionStatus = userDataHelper.getSubScreenUserData(nextProps.userData, this.state.screen.screen_id, this.state.conclusionScreen.data.screen_id).status;
            this.setState({
                conclusionStatus: conclusionStatus,
                //setEnabledHotSpots: true
            });
        }

        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({

                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                introduction_label: appHelper.getLocaleString("introduction_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                conclusion_label: appHelper.getLocaleString("conclusion_label"),
                scroll_label: appHelper.getLocaleString("scroll_label"),
            });
            this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
        }
        //this.setState({setEnabledHotSpots: true });
    }


    componentDidUpdate() {

        if (this.state.launchIntroduction) {
            this.readyIntroduction();
        }

        if (this.state.launchConclusion) {
            this.readyConclusion();
        }

        if (this.state.checkScrollPos) {
            this.checkScrolling();
        }

        if(this.state.doSetRenderedScreens){
            this.setRenderedScreens();
        }

        if(this.state.setEnabledHotSpots){
            this.setEnabledHotSpots();
        }
    }

    componentWillUnmount() {
        let feed = this.refs[`${this.state.screen.screen_id}_feed`];
        feed.removeEventListener("scroll", this.checkScrolling);
    }


    readySetRenderedScreens(){

        this.setState({
            setEnabledHotSpots: true
        });
    }

    setScreenAccessed(){
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    setScreenNotReadyYet() {
        this.setState({status: objectConstants.STATUS_COMPLETE});
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    readyIntroduction() {
        let launchScreen = this.launchScreen;
        let introductionScreen = this.state.introductionScreen;
        setTimeout(function () {
            launchScreen(introductionScreen);
        }, 1000);
    }

    readyConclusion() {
        let launchScreen = this.launchScreen;
        let conclusionScreen = this.state.conclusionScreen;
        setTimeout(function () {
            launchScreen(conclusionScreen);
        }, 1000);
    }

    setScreenTitle() {
        this.props.actions.setScreenTitle(this.state.locale.title);
    }

    checkScreenStatus() {
        let screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completeScreens
            });
        }
    }

    getAssets() {
        let background = {};
        let hotspotBackground = {};

        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        if (appHelper.isDefined(this.state.screen.assets.hotspot)) {
            hotspotBackground = appHelper.getHotspotBackgroundAsset(this.state.screen.assets.hotspot);
        }
        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
                hotspotBackground: appHelper.isDefined(hotspotBackground.src) ? hotspotBackground : this.state.assets.hotspotBackground
            }),
            checkScrollPos: true,
        });

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.biteCallbacks, {
                //onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                onSubScreenComplete: this.onSubScreenComplete,
                goToNextSubScreen: this.goToNextSubScreen,
                hasNextSubScreen: this.hasNextSubScreen,
                completeScreen: this.completeScreen,
                //objectIsEnabled: this.objectIsEnabled,
                //objectIsComplete: this.objectIsComplete,
                //storeUserResponse: this.storeUserResponse,
                //scrollTo: this.scrollTo,
                //isReviewMode: this.isReviewMode
            })
        });
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        return this.props.biteCallbacks.getBiteId();
    }

    showFooter() {

        return this.state.status === objectConstants.STATUS_COMPLETE || this.state.introductionStatus === objectConstants.STATUS_COMPLETE || this.state.conclusionStatus === objectConstants.STATUS_COMPLETE || this.state.scrollState === 'scroll' || this.state.isOpenNavigation;
    }

    hasFooterClass() {
        return this.showFooter() ? "include-footer" : "";
    }

    setEnabledHotSpots() {
        this.setState({setEnabledHotSpots: false});
        if ((appHelper.isDefined(this.state.screen.progression) && this.state.screen.progression === objectConstants.LINEAR) && this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({doSetRenderedScreens: true, enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0])});
        } else {
            this.setState({doSetRenderedScreens: true, enabledScreens: Object.assign([], this.state.screen.sub_screens)});
        }
    }

    checkScreenIsEnabled(screen) {
        let enabledIndex = appHelper.getArrayObjectIndexByKey(this.state.enabledScreens, "screen_id", screen.screen_id);
        return enabledIndex > -1;
    }

    setActiveHotspot(screen) {
        //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered

        this.setState(
            {
                activeScreen: screen
            }
        );

        if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT) {
            let renderedScreen = {};
            _.forEach(this.state.hotspotScreens, function (hs_screen) {
                if (hs_screen.data.screen_id === screen.screen_id) {
                    renderedScreen = Object.assign({}, hs_screen);
                }
            });
            this.launchScreen(renderedScreen);
        } else if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION) {
            this.launchScreen(this.state.introductionScreen);
        } else if (screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION) {
            this.launchScreen(this.state.conclusionScreen);
        }
    }

    setScreenHasBeenViewed(screen) {
        let viewedIndex = appHelper.getArrayObjectIndexByKey(this.state.viewedScreens, "screen_id", screen.screen_id);
        if (viewedIndex === -1) {
            this.setState({viewedObjects: dataHelper.immutablePush(this.state.viewedScreens, screen)});
        }

    }

    setRenderedScreens() {
        //console.log(`setRenderedScreens`);
        this.setState({doSetRenderedScreens: false});
        let hotspotScreens = [];
        let introductionScreen = {};
        let conclusionScreen = {};
        let introductionStatus = objectConstants.STATUS_NOT_STARTED;
        let conclusionStatus = objectConstants.STATUS_NOT_STARTED;
        let userData = this.state.userData;
        let screen = this.state.screen;

        _.forEach(this.state.screen.sub_screens, function (sub_screen) {
            let screenType = Object.assign({}, getScreenComponentByType(sub_screen.screen_type),
                {
                    data: sub_screen
                }
            );


            if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT) {
                hotspotScreens = dataHelper.immutablePush(hotspotScreens, screenType);
            } else if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION) {
                introductionScreen = Object.assign({}, screenType);
                introductionStatus = userDataHelper.getSubScreenUserData(userData, screen.screen_id, introductionScreen.data.screen_id).status;
                //console.log(`introductionStatus`,introductionStatus);
            } else if (screenType.data.hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION) {
                conclusionScreen = Object.assign({}, screenType);
                conclusionStatus = userDataHelper.getSubScreenUserData(userData, screen.screen_id, conclusionScreen.data.screen_id).status;
            }

        });

        let completeScreens = this.getCompletedSubScreens();
        let enabledScreens = this.getCompletedSubScreens();

        if (appHelper.isDefined(this.state.screen.progression) && this.state.screen.progression !== objectConstants.LINEAR) {
            enabledScreens = Object.assign([], this.state.screen.sub_screens);

        } else if (enabledScreens.length > 0 && enabledScreens.length < this.state.screen.sub_screens.length) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[enabledScreens.length]);
            enabledScreens = dataHelper.immutablePush(enabledScreens, nextScreen);
        }else{
            let firstScreen = Object.assign({}, this.state.screen.sub_screens[0]);
            enabledScreens = dataHelper.immutablePush(enabledScreens, firstScreen);

            //enabledScreens =  dataHelper.immutablePush(this.state.screen.sub_screens[0]);

        }

       // console.log(`completeScreens`,completeScreens);

        let introductionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", introductionScreen.screen_id);
        let conclusionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", conclusionScreen.screen_id);

        if (introductionIndex > -1) {
            introductionStatus = objectConstants.STATUS_COMPLETE;
        }

        if (conclusionIndex > -1) {
            conclusionStatus = objectConstants.STATUS_COMPLETE;
        }
        //console.log(`launchIntroduction`,this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE);
        //console.log(`launchConclusion`,completeScreens.length === (this.state.screen.sub_screens.length - 1) && this.state.hasConclusion && conclusionStatus !== objectConstants.STATUS_COMPLETE);

        this.setState({
            hotspotScreens: Object.assign([], hotspotScreens),
            introductionScreen: Object.assign({}, introductionScreen),
            introductionStatus: introductionStatus,
            conclusionScreen: Object.assign({}, conclusionScreen),
            conclusionStatus: conclusionStatus,
            launchIntroduction: this.state.hasIntroduction && introductionStatus !== objectConstants.STATUS_COMPLETE,
            enabledScreens: Object.assign([], enabledScreens),
            completeScreens: Object.assign([], completeScreens),
            launchConclusion: completeScreens.length === (this.state.screen.sub_screens.length - 1) && this.state.hasConclusion && conclusionStatus === objectConstants.STATUS_NOT_STARTED
        });
    }

    getCompletedSubScreens() {
        let completedScreens = [];
        let userData = this.state.userData;
        let parentScreen = this.state.screen;
        _.forEach(this.state.screen.sub_screens, function (sub_screen) {
            let screenUserData = userDataHelper.getSubScreenUserData(userData, parentScreen.screen_id, sub_screen.screen_id);
            if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
                completedScreens = dataHelper.immutablePush(completedScreens, sub_screen);
            }
        });

        return completedScreens;
    }


    onSubScreenComplete(screen) {
        let completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        let nextScreen = {};

        if (subScreenIndex < (this.state.screen.sub_screens.length - 1)) {
            nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
        }


        if (completionIndex === -1) {
            this.setState(
                {
                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
                    checkContinueBtnState: true,
                    checkNextSlideBtnState: true
                }
            );

            // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, screen.screen_id);
        }

        this.checkScreenComplete();

    }

    checkHotSpotsAreComplete() {
        let completedHotSpots = 0;
        let completeScreens = this.state.completeScreens;
        _.forEach(this.state.hotspotScreens, function (screen) {
            let screen_id = screen.data.screen_id;
            let completionIndex = appHelper.getArrayObjectIndexByKey(completeScreens, "screen_id", screen_id);
            if (completionIndex > -1) {
                completedHotSpots++;
            }
        });
        return completedHotSpots === this.state.hotspotScreens.length;
    }

    hasNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        return subScreenIndex < (this.state.screen.sub_screens.length - 1);
    }

    goToNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        if (this.hasNextSubScreen(screen)) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
            this.setActiveHotspot(nextScreen);
        } else {
            this.navigateToNextScreen();
        }
    }

    navigateToNextScreen() {

        if(this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS){
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }

            if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
                this.goToScreen(this.state.screen.next_screen_id);
            } else {
                let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    this.context.router.push('menu');
                } else {
                    this.props.actions.setNextLessonLocation(this.getScreenId());
                }
            }

    }

    checkScreenComplete() {
        if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
            this.setState(
                {
                    status: objectConstants.STATUS_COMPLETE
                }
            );
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }
    }

    //used when child screen terminates
    completeScreen() {
        this.setState(
            {
                status: objectConstants.STATUS_COMPLETE
            }
        );
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status,
            object_status: objectConstants.STATUS_COMPLETE,
        };
        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    launchScreen(renderedScreen) {

        this.setState({
            launchIntroduction: false,
            launchConclusion: false,
        });

        let config = Object.assign({}, SCREEN_CONFIG,
            {
                component: renderedScreen.component,
                biteCallbacks: this.state.callbacks,
                parentScreen: {
                    screen_id: this.state.screen.screen_id
                },
                screen: {
                    screen_id: renderedScreen.data.screen_id
                },
                onClose: this.onCloseScreen,
                sourceId: `hotSpot_${renderedScreen.data.screen_id}`

            }
        );

        this.props.actions.setNewScreenDialog(config);
    }

    onCloseScreen() {
        let launchConclusion = this.checkHotSpotsAreComplete() && this.state.hasConclusion && this.state.conclusionStatus === objectConstants.STATUS_NOT_STARTED;
        this.setState({launchConclusion: launchConclusion});
    }

    showIntroduction() {
        this.launchScreen(this.state.introductionScreen);
    }

    showConclusion() {
        this.launchScreen(this.state.conclusionScreen);
    }

    checkScrolling() {
        this.setState({checkScrollPos: false});
        let feed = this.refs[`${this.state.screen.screen_id}_feed`];
        let hotspot_background = this.refs[`${this.state.screen.screen_id}_background`];
        if (hotspot_background.offsetHeight > feed.offsetHeight && feed.scrollTop < (hotspot_background.offsetHeight - feed.offsetHeight) && (appHelper.isDefined(this.state.screen.scrollable) && this.state.screen.scrollable)) {
            this.setState({
                scrollState: "scroll"
            });
        } else {
            this.setState({
                scrollState: ""
            });
        }
    }

    scrollToBottom() {
        let feed = this.refs[`${this.state.screen.screen_id}_feed`];
        TweenLite.to(feed, 0.5, {
            scrollTop: feed.offsetHeight,
            ease: Expo.easeInOut,
        });
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.scrollToBottom();
        }
    }
    allowScroll(){
     return appHelper.isDefined(this.state.screen.scrollable) && this.state.screen.scrollable;
    }

    setButtonColour(){
        if(this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_NO_SCREEN || this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_FULL_SCREEN) {
            if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
                return {
                    background: this.state.screen.hotspot_colour,
                    color: this.state.screen.hotspot_label_colour
                };
            } else if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour === objectConstants.INHERIT) {
                return {
                    background: this.state.screen.hotspot_colour

                };
            } else if (this.state.screen.hotspot_colour === objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
                return {
                    color: this.state.screen.hotspot_label_colour
                };
            } else {
                return {};
            }
        }else{
            return {};
        }

    }

    render() {
        return (
            <div className="customer-scenario">
                <div className="background-container">
                    <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                </div>
                <div className="screen-container">
                    <div className={`hot-spot-screen ${this.state.screen.hotspot_type}`}>

                        {this.state.introductionStatus !== objectConstants.STATUS_NOT_STARTED
                            ?
                            <button className={`btn guroo-btn introduction-btn`} ref={`hotSpot_${this.state.introductionScreen.screen_id}`} id={`hotSpot_${this.state.introductionScreen.data.screen_id}`} tabIndex="0" onClick={this.showIntroduction} style={this.setButtonColour()}>{this.state.introduction_label}</button>
                            :
                            null
                        }
                        <div className={`hot-spot-content ${this.hasFooterClass()} ${!this.allowScroll() ? "no-scroll" : ""}`}
                             ref={`${this.state.screen.screen_id}_feed`}>
                            <div className="hot-spot-background-container"
                                 ref={`${this.state.screen.screen_id}_background`}>
                                {
                                    appHelper.isDefined(this.state.assets.hotspotBackground.src)
                                        ?
                                        <img
                                            className={this.state.screen.sub_screens.length === 0 ? "image-overlay" : "hot-spot-background"}
                                            src={this.getImagePath(this.state.assets.hotspotBackground.src)} alt=""/>
                                        :
                                        null
                                }

                                <div className="hot-spot-area">
                                    {this.state.screen.sub_screens.map(sub_screen =>

                                        sub_screen.hotspot_display_type === objectConstants.DISPLAY_TYPE_HOTSPOT && this.state.screenIsReady
                                            ?
                                            <HotSpot key={`${sub_screen.screen_id}_hotspot`}
                                                     parentScreen={this.state.screen}
                                                     screen={sub_screen}
                                                     activeScreenId={this.state.activeScreen.screen_id}
                                                     enabledScreens={this.state.enabledScreens}
                                                     completeScreens={this.state.completeScreens}
                                                     onClickFunc={this.setActiveHotspot}/>
                                            :
                                            null
                                    )}

                                    {
                                        !this.state.screenIsReady
                                            ?
                                            <div>
                                                {this.state.producerNotes.length > 0
                                                    ?
                                                    <ProducerNotes notes={this.state.producerNotes}
                                                                   screen_id={this.state.screen.screen_id}/>
                                                    :
                                                    null
                                                }
                                                <NotReadyYet screen_id={this.state.screen.screen_id}/>
                                                <Button ref={`${this.state.screen.screen_id}_button`}
                                                        label={this.state.continue_label}
                                                        id={`${this.state.screen.screen_id}_button`}
                                                        onClick={this.navigateToNextScreen}
                                                        onRevealed={this.onContinueBtnReveled}/>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
						{this.state.conclusionStatus !== objectConstants.STATUS_NOT_STARTED   || (this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS && (!this.state.hasIntroduction || (this.state.hasIntroduction && this.state.introductionStatus === objectConstants.STATUS_COMPLETE)) && appHelper.isDefined(this.state.conclusionScreen.data))
							?

							<button className={`btn guroo-btn conclusion-btn`} ref={`hotSpot_${this.state.conclusionScreen.screen_id}`} id={`hotSpot_${this.state.conclusionScreen.data.screen_id}`} tabIndex="0" onClick={this.showConclusion} style={this.setButtonColour()}>{this.state.conclusion_label}</button>
							:
							null
						}

                        {
                            this.showFooter()
                                ?
                                <div className={`hot-spot-footer ${this.state.scrollState}`}>

                                    <div className="footer-btn" onClick={this.scrollToBottom} onKeyDown={this.setKeyboardAccessibility} role="presentation" />
                                    <div className="footer-col"/>
                                    <div className="footer-col text-center">
                                        {
                                            this.state.scrollState === 'scroll' && this.state.screen.hotspot_type !== objectConstants.HOT_SPOT_TYPE_FULL_SCREEN

                                                ?
                                                <div className="scroll-instruction">{this.state.scroll_label}</div>
                                                :
                                                null
                                        }
                                    </div>
                                    <div className="footer-col text-right">

                                        {this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS
                                            ?
                                            <button className={`btn guroo-btn`} onClick={this.navigateToNextScreen} style={this.setButtonColour()}>{this.state.continue_label}</button>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                                :null
                        }
                    </div>
                </div>
            </div>


        );
    }
}


HotspotScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    hasIntroduction: PropTypes.bool.isRequired,
    hasConclusion: PropTypes.bool.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
};

HotspotScreen.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {

    let lastIndex = -1;
    let hasIntroduction = false;
    let hasConclusion = false;
    if (ownProps.screen.sub_screens.length > 0) {
        lastIndex = ownProps.screen.sub_screens.length - 1;
        hasIntroduction = ownProps.screen.sub_screens[0].hotspot_display_type === objectConstants.DISPLAY_TYPE_INTRODUCTION;
        hasConclusion = ownProps.screen.sub_screens[lastIndex].hotspot_display_type === objectConstants.DISPLAY_TYPE_CONCLUSION;
    }
    let lang = state.userData.lang;
    return {
        lang:lang,
        hasIntroduction: hasIntroduction,
        hasConclusion: hasConclusion,
        titles: state.titles,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HotspotScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/hotspotScreen/HotspotScreen.js
 **/